import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ContentWrapper } from "@insite/content-library/Widgets/Basic/RichContent";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
import * as React from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    pageContent: getCurrentPage(state).fields.content,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface BlogDetailContentWidgetStyles {
    wrapper?: InjectableCss;
}

export const blogDetailContentWidgetStyles: BlogDetailContentWidgetStyles = {};

const styles = blogDetailContentWidgetStyles;

const BlogDetailContentWidget = ({ pageContent }: Props) => (
    <ContentWrapper {...styles.wrapper} backgroundColor="transparent" padding={0}>
        {parse(pageContent, parserOptions)}
    </ContentWrapper>
);

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(BlogDetailContentWidget) as any,
    definition: {
        displayName: "Detail Content",
        group: "Verndale Box - Blog" as any,
        icon: "heading",
        allowedContexts: ["BlogDetailPage"] as any,
    },
};

export default widgetModule;
